import React from 'react';
import { Color, PieceType, PIECE_SYMBOLS } from '../types';
import { FAIRY_PIECE_PATHS, getFairyPieceKey } from './FairyPiecePaths';

interface PieceGlyphProps {
    piece: PieceType;
    color: Color;
    className?: string;
}

const FAIRY_PIECES = new Set<PieceType>(['H', 'E', 'A']);

// Safari doesn't apply web fonts to SMP Unicode characters (U+1FA4E–U+1FA53)
const isSafari = typeof navigator !== 'undefined' &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const PieceGlyph: React.FC<PieceGlyphProps> = ({ piece, color, className = '' }) => {
    const isFairy = FAIRY_PIECES.has(piece);
    const glyphClassName = ['piece-glyph', `piece-glyph--${color}`, isFairy ? 'piece-glyph--fairy' : '', className].filter(Boolean).join(' ');

    if (isSafari && FAIRY_PIECES.has(piece)) {
        const key = getFairyPieceKey(piece as 'H' | 'E' | 'A', color);
        const { viewBox, d } = FAIRY_PIECE_PATHS[key];
        return (
            <span className={glyphClassName} style={{ lineHeight: 1 }}>
                <svg
                    className="piece-glyph-svg"
                    viewBox={viewBox}
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                    style={{ display: 'inline', verticalAlign: '-0.125em' }}
                >
                    <path d={d} />
                </svg>
            </span>
        );
    }

    const symbol = PIECE_SYMBOLS[color][piece];
    return (
        <span
            className={glyphClassName}
            style={{
                fontFamily: 'Noto Sans Symbols 2, Segoe UI Symbol, Apple Symbols, sans-serif',
                fontWeight: 400,
                lineHeight: 1,
            }}
        >
            {symbol}
        </span>
    );
};
